var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#008CFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.625 1.583h5.75a.8.8 0 01.764.561l.32 1.022h0-7.917l.32-1.022a.796.796 0 01.762-.561zM2.75 3.958h9.5l-1.193 11.946a.8.8 0 01-.796.72h-5.52a.8.8 0 01-.796-.72L2.75 3.958h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.535 3.166h9.93c.345 0 .65.22.76.547l.258.775a.8.8 0 01-.759 1.053H2.277a.8.8 0 01-.759-1.053l.258-.775a.803.803 0 01.761-.547z"
  }))));
}
export default SvgDelete;